<template>
  <div
    :class="[
      'v-box',
      boxDisplay,
      boxItemAlignment,
      boxContentJustifyAlignment,
      boxFlexDirections,
      boxFlexGaps
    ]"
  >
    <slot />
  </div>
</template>

<script>
const composeClasses = (classVariant, classObj) => {
  return Object.entries(classObj)
    .map(arr => {
      if (!arr[0].length) return `${classVariant}-${arr[1]}${arr[0]}`;
      return `${classVariant}-${arr[1]}-${arr[0]}`;
    })
    .join(" ");
};

const displaies = Object.freeze({
  BLOCK: "block",
  FLEX: "flex"
});

const itemAlignments = Object.freeze({
  CENTER: "center",
  END: "end",
  START: "start"
});

const contentJustifyAlignments = Object.freeze({
  CENTER: "center",
  BETWEEN: "between",
  START: "start",
  END: "end"
});

const flexDirections = Object.freeze({
  ROW: "row",
  COLUMN: "column"
});

const flexGaps = Object.freeze({
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg"
});

export default {
  name: "BaseBox",
  props: {
    display: {
      type: String || Object,
      validator: value => Object.values(displaies).includes(value),
      default: () => displaies.BLOCK
    },
    alignItems: {
      required: false,
      type: String || Object,
      validator: value => Object.values(itemAlignments).includes(value),
      default: () => ""
    },
    justifyContent: {
      required: false,
      type: String || Object,
      validator: value =>
        Object.values(contentJustifyAlignments).includes(value),
      default: () => ""
    },
    flexDirection: {
      required: false,
      type: String || Object,
      validator: value => Object.values(flexDirections).includes(value),
      default: () => ""
    },
    gap: {
      required: false,
      type: String,
      validator: value => Object.values(flexGaps).includes(value),
      default: ""
    }
  },
  computed: {
    boxDisplay() {
      if (typeof this.display === "object") {
        return composeClasses("v-box", this.display);
      }
      return `v-box-${this.display}`;
    },
    boxItemAlignment() {
      if (typeof this.alignItems === "object") {
        return composeClasses("v-box-flex-items", this.alignItems);
      }
      return `v-box-flex-items-${this.alignItems}`;
    },
    boxContentJustifyAlignment() {
      if (typeof this.justifyContent === "object") {
        return composeClasses(
          "v-box-flex-justify-content",
          this.justifyContent
        );
      }
      return `v-box-flex-justify-content-${this.justifyContent}`;
    },
    boxFlexDirections() {
      if (typeof this.flexDirection === "object") {
        return composeClasses("v-box-flex", this.flexDirection);
      }
      return `v-box-flex-${this.flexDirection}`;
    },
    boxFlexGaps() {
      return `v-box-flex-gap-${this.gap}`;
    }
  }
};
</script>
